/* v8 ignore start */
import {LottieImageAssetModel} from "@/lib/lottie/assets/lottieImageAssetModel";
import {LottiePrecompositionModel} from "@/lib/lottie/assets/lottiePrecompositionModel";

export type TLottieAssetJson = LottieImageAssetModel.IJson | LottiePrecompositionModel.IJson;

export const lottieAssetModelResolver = (json: TLottieAssetJson) => {
  if (isPrecompositionAsset(json)) {
    return new LottiePrecompositionModel(json);
  } else {
    return new LottieImageAssetModel(json);
  }
};

function isPrecompositionAsset(asset: any): asset is LottiePrecompositionModel.IJson {
  return (asset as LottiePrecompositionModel.IJson).layers !== undefined;
}
/* v8 ignore stop */
